export default "__VITE_ASSET__52a7ed8f__"